
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sveden",
      function () {
        return require("private-next-pages/sveden/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sveden"])
      });
    }
  